/* BigDog 2026 — theme.js (vanilla, no dependencies) */
(() => {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const cfg = window.theme || { routes: {}, strings: {} };

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format = cfg.moneyFormat || '£{{amount}}') {
    const value = (Number(cents) || 0) / 100;
    const fmt = (n, dec, thou = ',', dsep = '.') => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? dsep + d : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0);
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        default: return fmt(value, 2);
      }
    });
  }

  /* ---------------- Toast ---------------- */
  let toastTimer;
  function toast(message) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }

  /* ---------------- Drawers ---------------- */
  let lastFocus = null;
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-drawer');
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const panel = $('.drawer__panel', drawer);
    requestAnimationFrame(() => panel && panel.focus());
    return true;
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('has-drawer');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const id = opener.dataset.drawerOpen;
      // Cart icon: only intercept when the cart drawer exists (no-JS falls back to /cart)
      if (openDrawer(id)) e.preventDefault();
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) closeDrawer(closer.closest('.drawer'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer($('.drawer.is-open'));
  });

  /* ---------------- Header shadow ---------------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------------- Reveal on scroll ---------------- */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------------- Cart (AJAX) ---------------- */
  const cartSections = 'cart-drawer';

  function renderCartSections(sections) {
    if (!sections) return;
    const html = sections['cart-drawer'];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('#CartDrawer', doc);
    const current = $('#CartDrawer');
    if (fresh && current) {
      const wasOpen = current.classList.contains('is-open');
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) {
        current.classList.add('is-open');
        current.setAttribute('aria-hidden', 'false');
      }
    }
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.dataset.count = count;
    });
  }
  async function refreshCount() {
    try {
      const cart = await fetch(`${cfg.routes.cart}.js`).then((r) => r.json());
      updateCount(cart.item_count);
    } catch (_) { /* ignore */ }
  }

  async function addToCart(formData) {
    formData.append('sections', cartSections);
    formData.append('sections_url', window.location.pathname);
    const res = await fetch(`${cfg.routes.cartAdd}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || cfg.strings.error);
    renderCartSections(data.sections);
    await refreshCount();
    return data;
  }

  async function changeLine(key, quantity) {
    const isCartPage = document.body.classList.contains('template-cart');
    const res = await fetch(`${cfg.routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: cartSections, sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || cfg.strings.error);
    if (isCartPage) { window.location.reload(); return; }
    renderCartSections(data.sections);
    updateCount(data.item_count);
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    btn.closest('.line-item')?.style.setProperty('opacity', '.5');
    try { await changeLine(btn.dataset.lineChange, Math.max(0, parseInt(btn.dataset.qtyTo, 10) || 0)); }
    catch (err) { toast(err.message); btn.closest('.line-item')?.style.removeProperty('opacity'); }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-line-input]');
    if (!input) return;
    try { await changeLine(input.dataset.lineInput, Math.max(0, parseInt(input.value, 10) || 0)); }
    catch (err) { toast(err.message); }
  });

  /* ---------------- Product page ---------------- */
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      const json = $('[data-product-json]', this);
      if (!json) return;
      this.product = JSON.parse(json.textContent);
      this.form = $('[data-product-form]', this) || $('form[action*="/cart/add"]', this);
      this.idInput = $('[data-variant-id]', this);
      this.addBtn = $('[data-add-button]', this);
      this.addText = $('[data-add-text]', this);
      this.track = $('[data-gallery-track]', this);

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-index]')) this.onOptionChange();
      });
      this.setupQty();
      this.setupGallery();
      this.setupSubmit();
      this.setupSticky();
      this.setupHelpers();
      this.updateAvailabilityMarks();
    }

    selectedOptions() {
      return $$('fieldset.option', this).map((fs) => {
        const checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    onOptionChange() {
      const opts = this.selectedOptions();
      opts.forEach((v, i) => { const out = $(`[data-option-value="${i}"]`, this); if (out) out.textContent = v; });
      const variant = this.product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      this.variant = variant;
      this.updateAvailabilityMarks();
      if (!variant) {
        this.setButton(false, cfg.strings.unavailable);
        return;
      }
      this.idInput.value = variant.id;
      this.renderPrice(variant);
      this.setButton(variant.available, variant.available ? cfg.strings.addToCart : cfg.strings.soldOut);
      const stock = $('[data-stock]', this);
      if (stock) {
        stock.classList.toggle('is-out', !variant.available);
        stock.textContent = variant.available ? stock.dataset.inText || stock.textContent : cfg.strings.soldOut;
      }
      if (variant.media_id) this.goToMedia(variant.media_id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    updateAvailabilityMarks() {
      const opts = this.selectedOptions();
      $$('fieldset.option', this).forEach((fs, idx) => {
        $$('input', fs).forEach((input) => {
          const candidate = opts.slice(); candidate[idx] = input.value;
          const match = this.product.variants.some((v) => v.available && v.options.every((o, i) => candidate[i] === null || o === candidate[i]));
          input.classList.toggle('is-unavailable', !match);
        });
      });
    }

    renderPrice(variant) {
      const onSale = variant.compare_at_price > variant.price;
      const html = `<div class="price price--large${onSale ? ' price--sale' : ''}"><span class="price__current">${formatMoney(variant.price)}</span>${onSale ? `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>` : ''}</div>`;
      const wrap = $('[data-price-wrap]', this);
      if (wrap) wrap.innerHTML = html;
      const sticky = $('[data-sticky-price]');
      if (sticky) sticky.innerHTML = html.replace(' price--large', '');
    }

    setButton(enabled, label) {
      if (!this.addBtn) return;
      this.addBtn.disabled = !enabled;
      if (this.addText) this.addText.textContent = label;
      const sticky = $('[data-sticky-add]');
      if (sticky) { sticky.disabled = !enabled; sticky.textContent = label; }
    }

    setupQty() {
      const wrap = $('[data-qty]', this);
      if (!wrap) return;
      const input = $('input', wrap);
      wrap.addEventListener('click', (e) => {
        if (e.target.closest('[data-qty-minus]')) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        if (e.target.closest('[data-qty-plus]')) input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    }

    setupGallery() {
      const track = this.track;
      if (!track) return;
      const slides = $$('.gallery__slide', track);
      const counter = $('[data-gallery-count]', this);
      const thumbs = $$('[data-thumb]', this);
      const indexNow = () => Math.round(track.scrollLeft / track.clientWidth);
      const go = (i) => track.scrollTo({ left: Math.max(0, Math.min(slides.length - 1, i)) * track.clientWidth, behavior: 'smooth' });
      $('[data-gallery-prev]', this)?.addEventListener('click', () => go(indexNow() - 1));
      $('[data-gallery-next]', this)?.addEventListener('click', () => go(indexNow() + 1));
      thumbs.forEach((t) => t.addEventListener('click', () => this.goToMedia(t.dataset.thumb)));
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const i = indexNow();
          if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
          thumbs.forEach((t, ti) => t.setAttribute('aria-current', ti === i ? 'true' : 'false'));
          ticking = false;
        });
      }, { passive: true });
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') go(indexNow() + 1);
        if (e.key === 'ArrowLeft') go(indexNow() - 1);
      });
    }

    goToMedia(id) {
      const slides = $$('.gallery__slide', this.track);
      const i = slides.findIndex((s) => String(s.dataset.mediaId) === String(id));
      if (i >= 0) this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    }

    setupSubmit() {
      if (!this.form) return;
      this.form.addEventListener('submit', async (e) => {
        if (!$('#CartDrawer')) return; // fall back to normal submit
        e.preventDefault();
        this.addBtn.classList.add('is-loading');
        try {
          await addToCart(new FormData(this.form));
          openDrawer('CartDrawer');
          if (window.uetq) window.uetq.push('event', 'add_to_cart', { ecomm_prodid: [String(this.idInput.value)], ecomm_pagetype: 'product' });
        } catch (err) {
          toast(err.message);
        } finally {
          this.addBtn.classList.remove('is-loading');
        }
      });
    }

    setupSticky() {
      const bar = $('[data-sticky-atc]');
      if (!bar || !this.addBtn) return;
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-sticky-add]', bar).tabIndex = show ? 0 : -1;
      });
      io.observe(this.addBtn);
      $('[data-sticky-add]', bar).addEventListener('click', () => {
        if (this.addBtn.disabled) return;
        this.addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.form.requestSubmit ? this.form.requestSubmit(this.addBtn) : this.addBtn.click();
      });
    }

    setupHelpers() {
      const stock = $('[data-stock]', this);
      if (stock) stock.dataset.inText = cfg.strings.inStock || 'In stock';
    }
  }
  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);

  /* ---------------- Modals & scroll helpers ---------------- */
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open-modal]');
    if (open) {
      const dlg = document.getElementById(open.dataset.openModal);
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    const close = e.target.closest('[data-close-modal]');
    if (close) { close.closest('dialog')?.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close();
    const to = e.target.closest('[data-scroll-to]');
    if (to) {
      const target = document.getElementById(to.dataset.scrollTo);
      if (target) {
        if (target.tagName === 'DETAILS') target.open = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  /* ---------------- Recommendations ---------------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const io = new IntersectionObserver(async ([entry], obs) => {
        if (!entry.isIntersecting) return;
        obs.disconnect();
        try {
          const html = await fetch(this.dataset.url).then((r) => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = $('product-recommendations', doc);
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
        } catch (_) { /* ignore */ }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  /* ---------------- Size finder ---------------- */
  class SizeFinder extends HTMLElement {
    connectedCallback() {
      this.sizes = JSON.parse($('[data-sizes]', this).textContent || '[]');
      this.strings = JSON.parse($('[data-strings]', this).textContent || '{}');
      this.range = $('[data-weight]', this);
      this.out = $('[data-weight-out]', this);
      this.range.addEventListener('input', () => { this.clearChips(); this.update(); });
      $$('[data-breed-weight]', this).forEach((chip) => chip.addEventListener('click', () => {
        this.clearChips();
        chip.setAttribute('aria-pressed', 'true');
        this.range.value = Math.min(Number(this.range.max), Number(chip.dataset.breedWeight));
        this.update(Number(chip.dataset.breedWeight));
      }));
      this.update();
    }
    clearChips() { $$('[data-breed-weight]', this).forEach((c) => c.setAttribute('aria-pressed', 'false')); }
    update(forced) {
      const kg = forced || Number(this.range.value);
      const pct = ((Number(this.range.value) - Number(this.range.min)) / (Number(this.range.max) - Number(this.range.min))) * 100;
      this.range.style.setProperty('--fill', `${pct}%`);
      this.out.innerHTML = `${kg}<small>kg</small>`;
      const max = this.sizes.reduce((m, s) => Math.max(m, Number(s.max)), 0);
      const label = $('[data-size-label]', this);
      const title = $('[data-size-title]', this);
      const detail = $('[data-size-detail]', this);
      if (kg > max) {
        label.textContent = '?';
        title.textContent = this.strings.overTitle;
        detail.textContent = this.strings.over;
        return;
      }
      const match = this.sizes.find((s) => kg >= Number(s.min) && kg <= Number(s.max)) || this.sizes[0];
      if (!match) return;
      label.textContent = match.label;
      title.textContent = (this.strings.title || 'Start with size %size%').replace('%size%', match.label);
      detail.textContent = match.detail;
    }
  }
  if (!customElements.get('size-finder')) customElements.define('size-finder', SizeFinder);

  /* ---------------- Collection helpers ---------------- */
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-auto-submit]')) {
      const form = e.target.form;
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  });
  // Strip empty params so URLs stay clean
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('[data-facets-form]')) return;
    $$('input, select', form).forEach((el) => { if (!el.value) el.disabled = true; });
  });
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-collapsible-toggle]');
    if (!toggle) return;
    const box = toggle.closest('[data-collapsible]');
    const collapsed = box.classList.toggle('is-collapsed');
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    toggle.textContent = collapsed ? toggle.dataset.more : toggle.dataset.less;
  });
})();
